import { formatEventTimeLocal, formatUtcIso, formatUtcSubtext } from "../lib/dashboardTime.js";
import { useReportingTimezone } from "../lib/ReportingTimezoneContext.js";

interface EventTimestampBlockProps {
  clientTimestamp: string;
  receivedAt?: string | null;
  compact?: boolean;
  /** UTC subtext (default true). Raw Events main table passes false. */
  showUtc?: boolean;
}

export function EventTimestampBlock({
  clientTimestamp,
  receivedAt,
  compact = false,
  showUtc = true,
}: EventTimestampBlockProps) {
  const tz = useReportingTimezone();
  const local = formatEventTimeLocal(clientTimestamp, tz);
  const utcSub = formatUtcSubtext(clientTimestamp);
  const iso = formatUtcIso(clientTimestamp);

  if (compact) {
    return (
      <span className="inline-flex flex-col">
        <span>{local}</span>
        {showUtc ? (
          <span className="text-[10px] text-text-secondary" title={iso}>
            {utcSub}
          </span>
        ) : null}
      </span>
    );
  }

  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-text-primary">{local}</span>
      {showUtc ? (
        <span className="text-[11px] text-text-secondary" title={iso}>
          {utcSub}
        </span>
      ) : null}
      {receivedAt && receivedAt !== clientTimestamp ? (
        <span className="text-[10px] text-text-secondary">
          Received {formatUtcSubtext(receivedAt)}
        </span>
      ) : null}
    </div>
  );
}
